import React, { Component } from 'react'
import { StyleSheet, css } from 'aphrodite'
import Dialog from '@material-ui/core/Dialog'
import { AppStyles, AppTheme } from '../styles/AppTheme'
import { UiHelper } from '../common/helpers/UiHelper'
import { AppButton } from '../common/components/AppButton'
import { Helper } from '../common/helpers/Helper'
import { UploadHelper } from '../common/helpers/UploadHelper'
import { AppHelper } from '../helpers/AppHelper'
import { Tooltip } from '@material-ui/core'
const { v4: uuidv4 } = require('uuid')

export class BulkUploadMediaDialog extends Component {

  constructor(props) {
    super(props)
    // Max file limit
    this.maxFilesAllowedToUpload = 20
    this.state = {
      files: [],
    }
  }

  onCloseModal() {
    this.props.onClosed()
  }


  validateVideo = (video, file, validation) => {
    if (!validation) return null

    const { maxWidthOrHeight, maxVideoDuration, fileSizeLimit } = validation

    // Check file size (bytes)
    if (file.size > fileSizeLimit) {
      return `File size exceeds ${Math.round(fileSizeLimit / 1000 / 1000)} MB`
    }

    // Check dimensions
    if (video.videoWidth > maxWidthOrHeight || video.videoHeight > maxWidthOrHeight) {
      return `Video dimensions exceed ${maxWidthOrHeight}px`
    }

    // Check duration
    if (video.duration > maxVideoDuration) {
      return `Video duration exceeds ${Math.round(maxVideoDuration)} sec`
    }

    return null
  }

  isValidFileTitle(file) {
    // Validate File Title Length
    const fileTitle = AppHelper.getBaseFileName(file.name);
    if (!fileTitle || fileTitle.length < 2 || fileTitle.length > 100) {
      return false
    }
    return true
  }

  handleFiles = (fileList) => {
    // Selected files and filter out non image and video files
    const allowedTypes = [
      'image/png',
      'image/jpeg',
      'image/jpg',
      'video/mp4'
    ]
    // Check all non supported files
    const fileArray = Array.from(fileList);
    const unsupportedFiles = fileArray.filter(
      file => !allowedTypes.includes(file.type)
    );
    if (unsupportedFiles.length > 0) {
      this.setState({ errMsg: Helper.getString('fileTypeNotSupported') })
      return
    }

    const incomingFiles = Array.from(fileList).filter(
      file => allowedTypes.includes(file.type)
    )
    const remainingSlots = this.maxFilesAllowedToUpload - this.state.files.length
    if (remainingSlots <= 0) return

    if (incomingFiles.length > remainingSlots) {
      /* Slice and take the remaining no of files from selected file list */
      // incomingFiles = incomingFiles.slice(0, remainingSlots)
      /* Show error and return */
      this.setState({ errMsg: Helper.getString('maxFilesAllowedNo').replace('NO_OF_FILE', remainingSlots) })
      return
    }

    const filesArray = []
    const validation = this.props.videoUploadValidation

    let processedCount = 0
    // Reset error message
    this.setState({ errMsg: '' })
    const addToFileList = () => {
      processedCount++
      if (processedCount === incomingFiles.length) {
        // const newFiles = [...this.state.files, ...filesArray]
        const newFiles = [...filesArray, ...this.state.files]
        this.setState({ files: newFiles }, () => {
          filesArray.forEach(f => {
            if (f.status === 'uploading') this._uploadSingleFile(f.id)
          })
        })
      }
    }

    incomingFiles.forEach(file => {
      const fileObj = URL.createObjectURL(file)
      const isVideo = AppHelper.getFileType(file) === 'VIDEO'
      const uniqueId = Date.now() + Math.random()
      const fileNameBase = isVideo ? (uuidv4() + '_' + Date.now()) : undefined

      if (isVideo) {
        // *** Check for valid file if video ***
        const video = document.createElement('video')
        video.src = fileObj
        video.preload = 'metadata'
        video.onloadedmetadata = () => {
          let error = null
          if (!this.isValidFileTitle(file) && !error) error = Helper.getString('fileTitleValidationMessage')
          if (!error) error = this.validateVideo(video, file, validation)
          filesArray.push({
            id: uniqueId,
            file,
            percent: 0,
            status: error ? 'failed' : 'uploading',
            error: error || undefined,
            duration: video.duration,
            videoObj: fileObj,
            options: {
              uploadLocation: this.props.uploadLocation,
              type: 'media',
              ext: 'mp4',
              fileNameBase,
            }
          })
          addToFileList()
        }
      } else {
        // Image or other file, upload
        let error = null
        if (!this.isValidFileTitle(file))  error = Helper.getString('fileTitleValidationMessage')
        filesArray.push({
          id: uniqueId,
          file,
          percent: 0,
          status: error ? 'failed' : 'uploading',
          error: error || undefined,
          duration: 10,
          imgObj: fileObj,
          options: {
            uploadLocation: this.props.uploadLocation,
            type: 'media',
            ext: 'jpg',
          }
        })
        addToFileList()
      }
    })
  }


  _uploadSingleFile = (fileId) => {
    const fileObj = this.state.files.find(f => f.id === fileId)
    if (!fileObj) return

    // For video: first upload thumbnail, then the video file itself
    if (AppHelper.getFileType(fileObj.file) === 'VIDEO') {
      // 1. Create a <video> element and set src to fileObj.videoObj
      const video = document.createElement('video')
      video.src = fileObj.videoObj
      // Pass a callback to be called after thumbnail upload success
      this._addThumbnailEventsForVideo(video, fileObj, fileObj.options.fileNameBase, () => {
        // This callback fires after thumbnail upload success!
        // Now upload the video file
        this._fetchUploadUrlAndUpload({
          file: fileObj.file,
          options: fileObj.options,
          onUploadCompleteCallback: (signedUploadInfo) => {
            this.setState(prevState => {
              const files = prevState.files.map(f =>
                f.id === fileId
                  ? { ...f, status: 'completed', percent: 100, signedUploadInfo }
                  : f
              )
              return { files }
            })
          },
          onProgress: (percent) => {
            const displayPercent = Math.round((Number(percent) || 0) * 100)
            this.setState(prevState => {
              const files = prevState.files.map(f =>
                f.id === fileId
                  ? { ...f, percent: displayPercent }
                  : f
              )
              return { files }
            })
          },
          onError: (errorMessage) => {
            this.setState(prevState => {
              const files = prevState.files.map(f =>
                f.id === fileId
                  ? { ...f, status: 'failed' }
                  : f
              )
              return { files }
            })
          }
        })
      })
      return
    }

    // For images (and other non-videos), upload as usual
    this._fetchUploadUrlAndUpload({
      file: fileObj.file,
      options: fileObj.options,
      onUploadCompleteCallback: (signedUploadInfo) => {
        this.setState(prevState => {
          const files = prevState.files.map(f =>
            f.id === fileId
              ? { ...f, status: 'completed', percent: 100, signedUploadInfo }
              : f
          )
          return { files }
        })
      },
      onProgress: (percent) => {
        const displayPercent = Math.round(Number(percent) || 0)
        this.setState(prevState => {
          const files = prevState.files.map(f =>
            f.id === fileId
              ? { ...f, percent: displayPercent }
              : f
          )
          return { files }
        })
      },
      onError: (errorMessage) => {
        this.setState(prevState => {
          const files = prevState.files.map(f =>
            f.id === fileId
              ? { ...f, status: 'failed' }
              : f
          )
          return { files }
        })
      }
    })
  }

  removeFile = (idx) => {
    const file = this.state.files[idx]
    if (file && file.videoObj) URL.revokeObjectURL(file.videoObj)
    this.setState(prev => ({
      files: prev.files.filter((file, i) => i !== idx)
    }))
  }

  _addThumbnailEventsForVideo = (video, fileObj, fileNameBase, onThumbnailUploaded) => {
    video.addEventListener('loadeddata', function () {
      video.currentTime = 0
    })
    video.addEventListener('seeked', function () {
      this.captureThumbnailFromVideo(video, fileObj, fileNameBase, onThumbnailUploaded)
      window.URL.revokeObjectURL(video.src)
    }.bind(this))
  }

  captureThumbnailFromVideo = (video, fileObj, fileNameBase, onThumbnailUploaded) => {
    if (video.readyState >= 2) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      let width = video.videoWidth
      let height = video.videoHeight

      const maxDimension = 1920
      if (width > height) {
        if (width > maxDimension) {
          height = Math.floor(height * (maxDimension / width))
          width = maxDimension
        }
      } else {
        if (height > maxDimension) {
          width = Math.floor(width * (maxDimension / height))
          height = maxDimension
        }
      }

      canvas.width = width
      canvas.height = height
      context.drawImage(video, 0, 0, canvas.width, canvas.height)
      canvas.toBlob(function (blob) {
        const thumbnailUrl = URL.createObjectURL(blob)
        this.setState(prevState => ({
          files: prevState.files.map(f =>
            f.id === fileObj.id
              ? { ...f, thumbnailUrl }
              : f
          )
        }))
        this.uploadThumbnail(blob, fileNameBase, onThumbnailUploaded)
      }.bind(this), 'image/jpeg', 0.5)
    }
  }

  uploadThumbnail = (file, fileNameBase, onThumbnailUploaded) => {
    const options = {
      uploadLocation: this.props.uploadLocation,
      type: 'media',
      ext: 'jpg',
      fileNameBase: fileNameBase + '_tn'
    }
    const props = {
      options,
      file,
      onUploadCompleteCallback: () => {
        if (onThumbnailUploaded) onThumbnailUploaded()
      }
    }
    this._fetchUploadUrlAndUpload(props)
  }

  // Adapt your upload code to accept per-file callbacks:
  _fetchUploadUrlAndUpload = (props) => {
    const { options, file, onUploadCompleteCallback, onProgress, onError } = props
    UploadHelper.fetchUploadUrl({}, options, (err, signedUploadInfo) => {
      if (err) {
        if (onError) onError(err)
        return
      }
      const uploadOptions = {
        pickerResult: file,
        signedUploadInfo: signedUploadInfo,
        onEvent: (type, percent) => {
          if (type === 'progress') {
            if (onProgress) onProgress(percent)
          } else if (type === 'load') {
            if (onUploadCompleteCallback) onUploadCompleteCallback(signedUploadInfo)
          } else if (type === 'error') {
            if (onError) onError(Helper.getString('fileUploadErr'))
          }
        }
      }
      UploadHelper.uploadFormDataWithProgress(uploadOptions)
    })
  }

  validateVideo = (video, file, validation) => {
    let error = null
    if (validation) {
      const { maxWidthOrHeight, maxVideoDuration, fileSizeLimit } = validation
      if (file.size > fileSizeLimit) {
        error = `File size exceeds ${Math.round(fileSizeLimit / 1000 / 1000)} MB`
      } else if (
        video.videoWidth > maxWidthOrHeight ||
        video.videoHeight > maxWidthOrHeight
      ) {
        error = `Video dimensions exceed ${maxWidthOrHeight}px`
      } else if (video.duration > maxVideoDuration) {
        error = `Video duration exceeds ${Math.round(maxVideoDuration)} sec`
      }
    }
    return error
  }

  getSaveFailedReason = (f) => {
    const { unsavedFiles = [] } = this.state;

    const unsaved = unsavedFiles.find((u) => {
      return u.file.id === f.id
    })
    if (unsaved) {
      return (
        <span className={css(Styles.statusTextFailed)}>
          {unsaved.reason.description || Helper.getString('fileSaveFailed')}
        </span>
      );
    }
    return null;
  }

  _renderThumbnail = (f) => {
    const fileType = AppHelper.getFileType(f.file)
    if (fileType === 'IMAGE') {
      return (
        <img src={f.imgObj} className={css(Styles.imgThumb)} alt={f.file.name} />
      )
    } else if (fileType === 'VIDEO') {
      if (f.thumbnailUrl) {
        return (
          <img src={f.thumbnailUrl} className={css(Styles.imgThumb)} alt='thumbnail' />
        )
      } else {
        return (
          <span className={css(Styles.fileIcon)}>
            <i className='material-icons-outlined'>insert_drive_file</i>
          </span>
        )
      }
    } else {
      return (
        <span className={css(Styles.fileIcon)}>
          <i className='material-icons-outlined'>insert_drive_file</i>
        </span>
      )
    }
  }

  render() {
    const { unsavedFiles = [] } = this.state
    const isFailedState = unsavedFiles.length > 0
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={false}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button
            className={css(Styles.modalCloseButton)}
            onClick={this.onCloseModal.bind(this)}
            disabled={this.state.inProcess}
          >
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <div className={css(Styles.inputsHolder)}>


            {/* Drag and Drop Media Here */}
            {!isFailedState && this.maxFilesAllowedToUpload !== this.state.files.length &&
              <div className={css(Styles.dropArea)}
                onDrop={e => {
                  e.preventDefault()
                  this.handleFiles(e.dataTransfer.files)
                }}>
                <input
                  type='file'
                  multiple
                  className={css(Styles.inputFile)}
                  accept='image/png, image/jpeg, image/jpg, video/mp4'
                  id='fileUploadInput'
                  onChange={e => this.handleFiles(e.target.files)}
                />
                <label htmlFor='fileUploadInput' className={css(Styles.dropContent)}>
                  <i className={css(Styles.uploadIcon) + ' material-icons-outlined'}>file_upload</i>
                  <span>
                    Drag &amp; Drop an image/video here or <span className={css(Styles.browse)}>Browse</span>
                  </span>
                </label>
              </div>
            }

            {/* Row Items */}
            {/* File List will show here */}
            {this.state.files && this.state.files.length > 0 &&
              <div className={css(Styles.droppedFilesHolder)}>
                {this.state.files.map((f, idx) => (
                  <div key={idx} className={css(Styles.fileRow)}>
                    {/* Thumbnail */}
                    <div className={css(Styles.thumb)}>
                      {this._renderThumbnail(f)}
                    </div>
                    {/* Info */}
                    <div className={css(Styles.fileInfoHolder)}>
                      {/* Info & Actions */}
                      <div className={css(Styles.fileInfoActionHolder)}>
                        {/* Info */}
                        <div className={css(Styles.fileInfo)}>
                          <div className={css(Styles.fileTitle)}>
                            {AppHelper.getBaseFileName(f.file.name)}
                          </div>
                          <div className={css(Styles.fileMeta)}>
                            <span className={css(Styles.badge)}>
                              {AppHelper.getFileType(f.file)}
                            </span>

                            {/* <span className={css(Styles.fileSize)}> */}
                            <span className={css(Styles.badge)}>
                              {(f.file.size / (1000 * 1000)).toFixed(1)} MB
                            </span>

                            {/* <span className={css(Styles.duration)}> */}
                            <span className={css(Styles.badge)}>
                              {AppHelper.getFileType(f.file) === 'IMAGE'
                                ? '10 sec'
                                : (f.duration ? `${f.duration} Sec` : '...')}
                            </span>
                          </div>
                        </div>
                        {/* Actions/status */}
                        <div className={css(Styles.fileActions)}>
                          <div className={css(Styles.statusText)}>
                            {/* Uploading */}
                            {f.status === 'uploading' &&
                              <div className={css(Styles.percentText)}>
                                <span className={css(Styles.statusTextUploading)}>
                                  {Math.round(f.percent)}%
                                </span>
                              </div>}
                            {/* Completed */}
                            {f.status === 'completed' && <span className={css(Styles.statusTextHolders)}>
                              <div className={css(Styles.messagesHolders)}>
                                {!isFailedState && <span className={css(Styles.statusTextCompleted)}>{Helper.getString('readyToSave')}</span>}
                                {this.getSaveFailedReason(f)}
                              </div>
                              {!isFailedState && <Tooltip title={'Remove'} classes={{ popper: css(Styles.tooltip) }}><img src={require('../assets/icons/close-circle.svg')} onClick={() => this.removeFile(idx)} className={css(Styles.removeBtn)} /></Tooltip>}
                            </span>}
                            {/* Failed */}
                            {f.status === 'failed' && (
                              <div>
                                <span className={css(Styles.statusTextHolders)}>
                                  <span className={css(Styles.statusTextFailed)}>
                                    {f.status === 'failed' && f.error && (<span className={css(Styles.statusTextFailed)}>{f.error}</span>)}
                                    <span>{Helper.getString('uploadFailed')}</span>
                                  </span>
                                  {!isFailedState && <Tooltip title={'Remove'} classes={{ popper: css(Styles.tooltip) }}><img src={require('../assets/icons/close-circle.svg')} onClick={() => this.removeFile(idx)} className={css(Styles.removeBtn)} /></Tooltip>}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* Progress Bar */}
                      {f.status === 'uploading' &&
                        <div className={css(Styles.progressBarWrap)}>
                          <div className={css(Styles.progressBar)}>
                            <div className={css(Styles.progress)} style={{ width: `${f.percent}%` }} />
                          </div>
                        </div>}
                    </div>
                  </div>
                ))}
              </div>
            }
            {/* Files Counts */}
            {this.state.files.length > 0 && (
              <div className={css(Styles.fileCountBar)}>
                <span>
                  {this.state.files.length} / {this.maxFilesAllowedToUpload} file{this.state.files.length > 1 ? 's' : ''} selected
                </span>
              </div>
            )}

            {/* Buttons */}
            <div className={css(Styles.actions)}>
              {this.state.errMsg &&
                <p className={css(Styles.errMsg)}>{this.state.errMsg}</p>
              }
              {isFailedState ? (
                <AppButton
                  buttonText={Helper.getString('okay')}
                  onClick={this.onCloseModal.bind(this)}
                />
              ) : (
                <AppButton
                  inProcess={this.state.savingInProgress || false}
                  buttonText={Helper.getString('save')}
                  onClick={() => {
                    if (this.props.onSave && typeof this.props.onSave === 'function') {
                      const uploadedFileList = this.state.files.filter(f => f.status === 'completed')
                      this.props.onSave({ uploadedFileList, caller: this })
                    }
                  }}
                // disabled={!this.isSaveEnabled()}
                />
              )}
            </div>

          </div>
        </div>
      </Dialog>
    )
  }

  // isSaveEnabled = () => {
  //   return this.state.files.some(f => f.status === 'completed')
  // }

}



const Styles = StyleSheet.create({

  // File List -- start
  fileInfoHolder: {
    flex: 1
  },
  fileInfoActionHolder: {
    display: 'flex',
    alignItems: 'center'
  },
  droppedFilesHolder: {
    maxHeight: '300px',
    overflowY: 'scroll',
    padding: '0px 16px',
    background: '#fafbfc',
    border: 'solid 1px #e0e0e0',
    borderRadius: '5px'
  },
  fileRow: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e5e5e5',
    padding: '12px 0',
    position: 'relative',
  },
  thumb: {
    width: 44,
    height: 44,
    borderRadius: 10,
    overflow: 'hidden',
    marginRight: 16,
    flexShrink: 0,
    background: '#f2f2f2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imgThumb: {
    width: 44,
    height: 44,
    objectFit: 'cover',
    display: 'block',
  },
  fileIcon: {
    fontSize: 28,
  },
  fileInfo: {
    flex: 1,
    minWidth: 0,
  },
  fileTitle: {
    fontWeight: 600,
    fontSize: 16,
    color: '#3c3c3c',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 400
  },
  fileMeta: {
    fontSize: 14,
    color: '#8a8a8a',
    display: 'flex',
    alignItems: 'center',
    // gap: 8,
    marginTop: 2,
  },
  badge: {
    background: '#ffffff',
    color: '#5a5a5a',
    border: 'solid 1px #ccc',
    padding: '2px 8px',
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 12,
    marginRight: 6,
  },
  fileSize: {
    fontWeight: 500,
    marginRight: 8,
  },
  duration: {
    background: '#eee',
    borderRadius: 5,
    padding: '0 5px',
    fontSize: 12,
  },
  progressBarWrap: {
    marginTop: 10,
  },
  progressBar: {
    // width: 200,
    height: 4,
    background: '#e7e7e7',
    borderRadius: 4,
    overflow: 'hidden',
    marginTop: 3,
  },
  progress: {
    height: 4,
    // background: AppTheme.primaryColor,
    background: AppTheme.primaryColor,
    borderRadius: 4,
    transition: 'width 0.3s',
  },
  fileActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10
  },
  statusText: {},
  statusTextHolders: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    maxWidth: 240
  },
  statusTextUploading: {
    fontSize: 13,
    color: AppTheme.primaryColor,
    fontWeight: 600,
  },
  statusTextFailed: {
    fontSize: 12,
    color: '#F44336',
    fontWeight: 600,
    display: 'flex',
    flexDirection: 'column'
  },
  statusTextCompleted: {
    fontSize: 13,
    color: '#00c408',
    fontWeight: 600,
  },
  percentText: {
    fontWeight: 600,
    color: '#3c3c3c',
    fontSize: 16,
  },
  removeBtn: {
    border: 'none',
    background: 'transparent',
    fontSize: 20,
    color: '#f44',
    cursor: 'pointer',
    padding: 0,
  },
  actionBtn: {
    border: 'none',
    background: 'transparent',
    color: '#18a0fb',
    cursor: 'pointer',
    fontSize: 20,
    marginLeft: 7,
  },

  // File List -- ends

  // Drag and drop -- start
  dropArea: {
    border: '1px dashed rgb(229, 229, 229)',
    borderRadius: 10,
    // padding: 18,
    textAlign: 'center',
    background: '#fafbfc',
    minHeight: 70,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
    transition: 'border-color 0.2s',
    ':hover': {
      borderColor: '#6a6a6aff'
    },
    padding: '0px 10px'
  },
  inputFile: {
    opacity: 0,
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    zIndex: 2,
  },
  dropContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    fontSize: 14,
    color: '#222',
    width: '100%',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 1,
  },
  uploadIcon: {
    color: AppTheme.primaryColor,
    fontSize: 35,
    fontWeight: 600,
    marginRight: 8,
    marginTop: -3,
  },
  browse: {
    color: AppTheme.primaryColor,
    cursor: 'pointer',
    textDecoration: 'none'
  },

  // Drag and drop --- ends

  inputsHolder: {
    minWidth: 700,
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 20px',
    gap: 10,
    '@media (max-width: 767px)': {
      minWidth: 'auto !important'
    }
  },
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  modalContent: {
    minWidth: 200,
    padding: 10,
    paddingTop: 0,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius,
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 20,
  },
  fileCountBar: {
    fontWeight: 500,
    fontSize: 14,
    margin: '0px 0 7px 3px',
    letterSpacing: 0.1,
  },
  errMsg: {
    margin: 0,
    color: 'red',
    fontSize: 14,
    marginRight: 10
  },
  messagesHolders: {
    display: 'flex',
    // alignItems: 'center'
    flexDirection: 'column'
  },
  tooltip: {
    zIndex: '99999  !important'
  }
})



// WEBPACK FOOTER //
// ./src/components/BulkUploadMediaDialog.js